// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"EmailDeal-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/EmailDeal/EmailDeal.desktop.scss
 ** module id = 913
 ** module chunks = 1
 **/